/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ERP API
 * 날짜·요일·시간 요청 및 응답은 UTC 기준입니다. 시간대 없는 date/time/date-time 값도 UTC로 해석하며 서버에서 KST로 변환하지 않습니다. 프런트에서 시간대를 변환할 때 날짜와 요일도 함께 변환해야 합니다. 날짜 검색의 from/to는 UTC 시작 포함·종료 미포함입니다. time_zone을 지원하는 조회의 날짜 그룹은 해당 시간대를 따릅니다. 생일 등 날짜 자체를 의미하는 값은 입력한 날짜를 그대로 사용합니다.
 * OpenAPI spec version: v1
 */
import type {
  AuthExistsLoginIdParams,
  BaseResponseLoginIdExistsResponse,
  BaseResponseLoginResponse,
  BaseResponseVoid,
  LoginRequest,
  PasswordResetConfirmRequest,
  PasswordResetRequest,
} from '.././models';

import { customInstance } from '../../../../shared/apiClient/orvalMutator';

export const getAuth = () => {
  /**
   * @summary 리프레시 토큰으로 토큰 재발급
   */
  const authRefresh = () => {
    return customInstance<BaseResponseLoginResponse>({ url: `/api/auth/refresh`, method: 'POST' });
  };
  /**
   * @summary 비밀번호 재설정 메일 요청
   */
  const authRequestPasswordReset = (passwordResetRequest: PasswordResetRequest) => {
    return customInstance<BaseResponseVoid>({
      url: `/api/auth/password-reset/request`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: passwordResetRequest,
    });
  };
  /**
   * @summary 비밀번호 재설정
   */
  const authConfirmPasswordReset = (passwordResetConfirmRequest: PasswordResetConfirmRequest) => {
    return customInstance<BaseResponseVoid>({
      url: `/api/auth/password-reset/confirm`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: passwordResetConfirmRequest,
    });
  };
  /**
   * @summary 로그인
   */
  const authLogin = (loginRequest: LoginRequest) => {
    return customInstance<BaseResponseLoginResponse>({
      url: `/api/auth/login`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: loginRequest,
    });
  };
  /**
   * 로그인 ID의 존재 여부(exists)와 해당 사용자 이름(user_name)을 반환합니다. 로그인 ID가 없거나 연결된 사용자를 조회할 수 없으면 user_name은 null입니다.
   * @summary 로그인 ID 존재 여부 확인
   */
  const authExistsLoginId = (params: AuthExistsLoginIdParams) => {
    return customInstance<BaseResponseLoginIdExistsResponse>({ url: `/api/auth/login-id/exists`, method: 'GET', params });
  };
  return { authRefresh, authRequestPasswordReset, authConfirmPasswordReset, authLogin, authExistsLoginId };
};
export type AuthRefreshResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAuth>['authRefresh']>>>;
export type AuthRequestPasswordResetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAuth>['authRequestPasswordReset']>>>;
export type AuthConfirmPasswordResetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAuth>['authConfirmPasswordReset']>>>;
export type AuthLoginResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAuth>['authLogin']>>>;
export type AuthExistsLoginIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAuth>['authExistsLoginId']>>>;
